import React, { Component } from 'react';
import { trackEvent } from 'react-with-analytics';
import ReCAPTCHA from 'react-google-recaptcha';

import '../css/components/Formulaire.css';

import ZigZag from './ZigZag';

const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const encode = (data) => {
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
}

class FormulaireDeRecrutement extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };

        this.show = props.show;

        this.jsonData = [
            { 'key': 'Développeuse / développeur', 'selected': false },
            { 'key': 'Tech Lead', 'selected': false },
            { 'key': 'Autonome', 'selected': false },
            { 'key': 'Curieux', 'selected': false },
            { 'key': 'Backend', 'selected': false },
            { 'key': 'Java', 'selected': false },
            { 'key': '.NET', 'selected': false },
            { 'key': 'Python', 'selected': false },
            { 'key': 'Frontend', 'selected': false },
            { 'key': 'Angular', 'selected': false },
            { 'key': 'ReactJS', 'selected': false },
        ];

        this.onCancel = props.onCancel;

        this.selectTag = this.selectTag.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    selectTag(index) {
        this.jsonData[index].selected = !this.jsonData[index].selected;

        var hints = [];
        for (let index = 0; index < this.jsonData.length; index++) {
            if (this.jsonData[index].selected) {
                hints.push(this.jsonData[index].key);
            }
        }

        var newState = this.state;
        newState['skills'] = hints.join(', ');
        this.setState(newState);
    }

    handleChange(event) {
        var newState = this.state;
        newState[event.target.name] = event.target.value;
        this.setState(newState);
    }

    handleRecaptcha = value => {
        var newState = this.state;
        newState['g-recaptcha-response'] = value;
        this.setState(newState);
    };

    handleSubmit(event) {
        trackEvent('Interactions', 'Envoi de formulaire', 'Formulaire de recrutement');

        fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: encode({ "form-name": "recrutement", ...this.state })
        })
        .then((data) => {
            this.onCancel();
        })
        .catch(error => console.log(error));

        event.preventDefault();
    }

    allTags() {
        let rows = [];

        for (let index = 0; index < this.jsonData.length; index++) {
            rows.push(<span key={this.jsonData[index].key} className={"selectable-tag " + (this.jsonData[index].selected ? 'selected' : '')} onClick={() => this.selectTag(index)}>{this.jsonData[index].key}</span>)
        }

        return rows;
    }

    componentWillReceiveProps(newProps){
        this.show = newProps.show;
        this.forceUpdate();
    }

  render() {
        return (
            this.show ? (
                <div className="form-container">
                    <div className="form-overlay" onClick={this.onCancel} />
                    <div className="form">
                        <div onClick={this.onCancel} className="form-close">&#215;</div>
                        <div className="form-content">
                            <section className="form-header bloc-texte">
                                <ZigZag />
                                <h2>Nous recrutons !</h2>
                                <ZigZag />
                                <p>
                                    Vous souhaitez rejoindre notre équipe ?
                                    <br />
                                    Contactez-nous et nous reviendrons vers vous au plus vite.
                                </p>
                            </section>
                            <form onSubmit={this.handleSubmit} netlify netlify-recaptcha netlify-honeypot="bot-field">
                                <div className="recaptcha">
                                    <ReCAPTCHA ref="recaptcha" sitekey={RECAPTCHA_KEY} onChange={this.handleRecaptcha} />
                                </div>

                                <h3>Vous :</h3>
                                <div className="input-group">
                                    <input type="text" name="name" onChange={this.handleChange} placeholder="Nom et prénom" required />
                                    <input type="text" name="salary" onChange={this.handleChange} placeholder="Prétentions salariales" required />
                                </div>
                                <div className="input-group">
                                    <input type="email" name="email" onChange={this.handleChange} placeholder="E-mail" required />
                                    <input type="phone" name="phone" onChange={this.handleChange} placeholder="Téléphone" required />
                                </div>
                                <h3>Vos souhaits :</h3>
                                <p>Choisissez ce que vous voulez faire chez nous parmi nos besoins actuels :</p>
                                <div className="bloc-tags">
                                    {this.allTags()}
                                </div>
                                <h3>Expliquez nous en quelques mots qui vous êtes et ce que vous cherchez :</h3>
                                <textarea name="summary" onChange={this.handleChange}></textarea>

                                <button type="submit" className="btn btn-black">Envoyez votre candidature</button>
                            </form>
                        </div>
                    </div>
                </div>
            ) : null
        );
  }
}

export default FormulaireDeRecrutement;



// WEBPACK FOOTER //
// ./src/components/FormulaireDeRecrutement.js